import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchStudentAbsence = (args) => {
    return useQuery({
        queryKey: ['student', 'absence', 'list', args],
        queryFn: ({pageParam = args.page ?? 1}) => (((config) => {
            return generalRequest.get(`/student/absences`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiSearchTeacherLessonTimes = (args) => {
    return useQuery({
        queryKey: ['teacher', 'lesson', 'get', 'times', args],
        queryFn: () => ((async (args) => {
            return generalRequest.get(`/teacher/lessons/${args?.lesson_id}/times`, {params: args})
        })(args)),
    })
}


export const useApiGetTeacherLessonSessionDetail = (args) => {
    return useQuery({
        enabled: !!args?.enabled,
        queryKey: [
            'teacher',
            'lesson',
            'session-detail',
            'get',
            args?.lesson_id,
            args?.time_id,
            args?.date
        ],
        queryFn: () => ((async (args) => {
            return generalRequest.get(`/teacher/lessons/${args?.lesson_id}/times/${args?.time_id}/${args?.date}`)
        })(args)),
    })
}


export function useApiPutTeacherLessonAttendance() {
    return useMutation({
        mutationFn: (data) =>
            (((data) => {
                return generalRequest.put(`/teacher/lessons/${data?.lesson_id}/attendance`, data)
            })(data))
    });
}
